import * as type from './types';

export function submitBid(data) {
    return {
        type: type.POST_SUBMIT_BID_REQUESTED,
        data: data,
    }
}